export class CheckUtils {
  static isValidEmail(email?: string) {
    if (!email) return false
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return emailRegex.test(email)
  }

  static isValidMobile(mobile?: string) {
    if (!mobile) return false
    const mobileRegex = /^\d{6,18}$/
    return mobileRegex.test(mobile)
  }

  static isRegisterMobile(value: string) {
    // 前3为数字，并且所有字符都是数字返回true, 否则false
    const mobileRegex = /^[0-9]{2}[0-9]+$/
    return mobileRegex.test(value)
  }

  static isValidUsername(value: string) {
    const usernameRegex = /^[a-zA-Z][a-zA-Z0-9_]{4,19}$/
    return usernameRegex.test(value)
  }

  static isValidNumber(value: string) {
    const numberRegex = /^[0-9]+$/
    return numberRegex.test(value)
  }
}
